import { createFileRoute } from "@tanstack/react-router";
import { monthSearchSchema } from "../../-lib/month-search-schema";



export const Route = createFileRoute("/_protected/dashboard/metrics/_details")({
  validateSearch: monthSearchSchema
});
